module.exports = __webpack_public_path__ + "img/shopwillowbrookcom.e8ca342b.png";